'use strict';

angular.module('core').directive('currentYear', [
	function () {
		return {
			restrict: 'E',
			scope: {},
			controller: function () {
				this.getYear = function() {
					var now = new Date();
					return now.getUTCFullYear();
				};
			},
			controllerAs: 'ctrl',
			bindToController: true,
			template: '{{ctrl.getYear()}}'
		};
	}
]);
